module.exports = __webpack_public_path__ + "img/PAW.Flyer.1.34668955.jpg";